import { render, staticRenderFns } from "./todo.vue?vue&type=template&id=a4af8238&scoped=true&"
import script from "./todo.vue?vue&type=script&lang=js&"
export * from "./todo.vue?vue&type=script&lang=js&"
import style0 from "./todo.vue?vue&type=style&index=0&id=a4af8238&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4af8238",
  null
  
)

export default component.exports